import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-mfk',
    templateUrl: './mfk.component.html',
})
export class MfkComponent implements OnInit {
    constructor(private readonly route: ActivatedRoute) { }

    ngOnInit(): void {
        window.open('https://apps.its.uiowa.edu/mfk/index.jsp', '_blank');
    }
}